import { Box, Grid } from "@mui/material";
import React from "react";
import DrawingSelection from "../Components/DrawingSelection";
import TabControl from "./components/TabControl";
import ConsolidateModal from "./components/ConsolidateModal";
import DrawingBomTable from "./components/DrawingBomTable/DrawingBomTable";
import { DrawingBomContext } from "./DrawingBomContext";
import AddSrvModal from "./components/AddSrvModal";
import { useBOMDashboardContext } from "../BOMDashboard.context";
import LabelledBox from "../../../../../../../components/widgets/LabelledBox";
import ComparingModal from "./components/CompareModal";
import MtrModal from "./components/MtrModal";
import ChangeOrderModalModal from "./components/ChangeOrderModal";

export default function Main({ autoDrawingId }) {
  const { selectedDrawings, handleAddingNewDrawing } =
    React.useContext(DrawingBomContext);

  const { setSelectedDrawings } = useBOMDashboardContext();

  return (
    <Box sx={{ mx: 1 }}>
      <Grid container sx={{}}>
        <Grid item xs={12} xl={6}>
          <LabelledBox>
            <DrawingSelection
              selectedDrawings={selectedDrawings}
              handleAddingNewDrawing={handleAddingNewDrawing}
              setSelectedDrawings={setSelectedDrawings}
              autoDrawingId={autoDrawingId}
            />
          </LabelledBox>
        </Grid>

        <Grid
          item
          xs={12}
          xl={6}
          sx={{
            display: "flex",
            flexDirection: { xs: "row", xl: "row-reverse" },
          }}
        >
          {/* <Box>
              <SelectMaterialType />
            </Box> */}
          <TabControl />

          <ConsolidateModal />
          <ChangeOrderModalModal />
          <AddSrvModal />
          <ComparingModal />
          <MtrModal />
        </Grid>
      </Grid>

      <Box>
        <DrawingBomTable />
      </Box>
    </Box>
  );
}
